export default __webpack_public_path__ + "static/media/why-idn.cff00f89.jpg";